import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Routes } from '../../routes/routes';
import { Provider as AlertProvider } from 'react-alert';
import { AlertMolecule } from '../../components/molecules/alert/alert.molecule';
import { LoadingProvider } from './loading.provider';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';
import { RecaptchaProvider } from './recaptcha.provider';
import { PayPalProvider } from './paypal.provider';
import { GlobalStyle } from '../global-style/global-style';

export const AppProvider = () => {
  return (
    <RecaptchaProvider>
      <I18nextProvider i18n={i18n}>
        <LoadingProvider>
          <PayPalProvider>
            <AlertProvider template={AlertMolecule}>
              <BrowserRouter>
                <GlobalStyle />
                <Routes />
              </BrowserRouter>
            </AlertProvider>
          </PayPalProvider>
        </LoadingProvider>
      </I18nextProvider>
    </RecaptchaProvider>
  );
};
